import * as React from "react";
import "../../style/fonts.css";
import "./progressComp.css";
import Checkbox from "../checkbox_progress/checkboxProgress";

export interface Props {
  type: string;
  isSelected: boolean;
}

class ProgressComp extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.isSelected)
      return (
        <div className="PROGRESS_COMP_CHECKED">
          <div className="PROGRESS_TEXT">
            <div className="TITLE_3">{this.props.type}</div>
          </div>
          <div className="CHECKBOX_PROGRESS">
            <Checkbox isChecked={this.props.isSelected} />
          </div>
        </div>
      );
    else {
      return (
        <div className="PROGRESS_COMP_UNCHECKED">
          <div className="PROGRESS_TEXT">
            <div className="TITLE_3">{this.props.type}</div>
          </div>
          <div className="CHECKBOX_PROGRESS">
            <Checkbox isChecked={this.props.isSelected} />
          </div>
        </div>
      );
    }
  }
}

export default ProgressComp;



// WEBPACK FOOTER //
// ./src/components/Registration/progressComp.tsx